<mat-nav-list [disableRipple]="true">
  <div
       class="menu-search-input d-flex align-items-center justify-content-between position-relative {{ layout.menu.sideNavExpanded ? 'px-3' : 'pl-2' }} mx-0 mb-1">
    @if (layout.menu.sideNavExpanded) {
    <input #searchInput
           type="text"
           class="search-input form-control"
           placeholder="Buscar por menus"
           [formControl]="searchInputFormControl">

    @if (searchInput.value) {
    <button class="clear-search-input-button"
            color="accent"
            (click)="searchInputFormControl?.setValue(''); focusSearchInput()">
      <mat-icon color="accent">close</mat-icon>
    </button>
    }
    <div (click)="searchInput?.focus()"
         style="height: 24px;">
      <mat-icon>search</mat-icon>
    </div>
    } @else {
    <div (click)="layout.toggleSidenav(); focusSearchInput()">
      <mat-icon>search</mat-icon>
    </div>
    }

  </div>

  @for (item of menusToDisplay; track $index) {
  <ng-container>
    <!-- bypassAccessProfile: grupo com item por papel (liberação de títulos vencidos, D16), visível mesmo com perfil de acesso -->
    @if (
    (!item.hideInProduction || !isProduction || isTecincoMember) &&
    (
    (
    !item.blockedRoles?.includes(userRole) &&
    !accessProfile
    ) ||
    (
    accessProfile &&
    (accessProfile | canAccess: (item.topLevelProfileModule ?? item.profileModule) : true)
    ) ||
    (
    item.bypassAccessProfile &&
    !item.blockedRoles?.includes(userRole)
    ) ||
    (
    item.component === "favorites"
    )
    )
    ) {
    <a mat-list-item
       (click)="navigateOrExpand(item); resetCache(item.component)"
       [title]="layout.menu.sideNavExpanded ? '' : (('MENU.' + item?.component) | translate)"
       class="menu-item"
       [class.selected]="(layout.component | menuSelected : item : layout.menu[item.component] : false )">
      @if (item.icon) {
      <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
      } @else if (item.svgIcon) {
      <mat-icon matListItemIcon
                style="display: block;"
                [svgIcon]="item.svgIcon"></mat-icon>
      }

      @if (layout.menu.sideNavExpanded) {
      <h3 matListItemTitle>{{ ('MENU.' + item.component) | translate }}</h3>
      }

      @if (item.children && layout.menu.sideNavExpanded) {
      <button mat-icon-button
              matListItemMeta>
        <!-- style="align-self: center !important;" -->
        @if(((layout.menu.elementExpandend?.component === item.component) || layout.menu.expandAll)){
        <mat-icon>expand_more</mat-icon>
        } @else {
        <mat-icon>expand_less</mat-icon>
        }
      </button>
      }
    </a>
    }

    @if ((!item.hideInProduction || !isProduction || isTecincoMember) && (
    (
    !item.blockedRoles?.includes(userRole)
    &&
    !(accessProfile)
    )
    ||
    (
    (accessProfile)
    &&
    ((accessProfile) | canAccess: item.profileModule : true)
    )
    )
    && (((layout.menu.elementExpandend?.component === item.component) || layout.menu.expandAll))
    && item.children
    && (!item.inDevelopment || !isProduction)
    ) {
    @for (child of item.children; track $index) {
    <ng-container>
      <ng-container>
        <!-- bypassAccessProfile: item por papel (liberação de títulos vencidos, D16), visível mesmo com perfil de acesso -->
        @if((!child.hideInProduction || !isProduction || isTecincoMember) && ((
        (
        child.profileRule
        &&
        (accessProfile) &&
        (accessProfile | canAccess: child.profileRule)
        )
        ||
        (
        child.profileModule
        &&
        (accessProfile)
        &&
        ((accessProfile) | canAccess: child.profileModule : true)
        )

        ) || (
        !child.blockedRoles?.includes(userRole)
        &&
        !(accessProfile)
        ) || (
        !child.blockedRoles
        &&
        !child.profileRule
        &&
        !child.profileModule
        ) || (
        child.bypassAccessProfile
        &&
        !child.blockedRoles?.includes(userRole)
        ))
        && (!child.inDevelopment || !isProduction)
        && !(child.blockedProfileRule && (accessProfile) && ((accessProfile) | canAccess: child.blockedProfileRule))
        ) {
        <!-- class="menu-item" -->
        <a mat-list-item
           [routerLink]="child.href"
           [queryParams]="child.queryParams"
           (click)="navigateOrExpand(child); resetCache(child.component)"
           class="sub-item"
           [class.selected]="(layout.component === child.component || child.shadows?.includes(layout.component))">
          @if (child.icon) {
          <mat-icon matListItemIcon>{{ child.icon }}</mat-icon>
          } @else if (child.svgIcon) {
          <mat-icon matListItemIcon
                    style="display: block;"
                    [svgIcon]="child.svgIcon"></mat-icon>
          }
          <h3 matListItemTitle> {{ ('MENU.' + child.component) | translate }} </h3>
          @if (child.children?.length && layout.menu.sideNavExpanded) {
          <button mat-icon-button
                  matListItemMeta>
            @if((layout.menu.elementExpandend?.child === child.component) || layout.menu.expandAll){
            <mat-icon>expand_more</mat-icon>
            } @else {
            <mat-icon>expand_less</mat-icon>
            }
          </button>
          }
        </a>

        @for (subChild of child?.children ?? []; track $index) {
        <ng-container>
          @if((!subChild.hideInProduction || !isProduction || isTecincoMember) && ((
          (accessProfile) &&
          (accessProfile | canAccess: subChild.profileRule)
          ) || (
          !subChild.blockedRoles?.includes(userRole)
          &&
          !(accessProfile)
          ))
          && (!subChild.inDevelopment || !isProduction)
          && (((layout.menu.elementExpandend?.child === child.component) || layout.menu.expandAll))
          ) {
          <a mat-list-item
             [routerLink]="subChild.href"
             [queryParams]="subChild.queryParams"
             (click)="resetCache(subChild.component)"
             class="sub-item"
             [class.selected]="(layout.component === subChild.component || subChild.shadows?.includes(layout.component))">
            @if (subChild.icon) {
            <mat-icon matListItemIcon>{{ subChild.icon }}</mat-icon>
            } @else if (subChild.svgIcon) {
            <mat-icon matListItemIcon
                      style="display: block;"
                      [svgIcon]="subChild.svgIcon"></mat-icon>
            }
            <h3 matListItemTitle
                class="padding-left-grandchild"> {{ ('MENU.' + subChild.component) | translate }} </h3>
          </a>
          }
        </ng-container>
        }
        }
      </ng-container>
    </ng-container>
    }
    }
  </ng-container>
  }
</mat-nav-list>